<template>
  <div class="roleList">
    <el-card class="box-card fl" style="width: 35%;margin-left: 10px;">
      <div slot="header" class="clearfix header">
        <span class="card-header fl">角色信息</span>
        <el-button class="fr" size="mini" type="success" v-if="basicsAuth.roleAdd" @click="AddMenuForm()">新增</el-button>
      </div>
      <el-row>
        <el-table :data="roleInfo" highlight-current-row border style="width: 100%;overflow: hidden;" 
          :header-cell-style="{'text-align':'center'}"  @row-click="openDetails">
          <el-table-column prop="roleName" label="角色名称" width="150" align="center" sortable>
          </el-table-column>
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <el-dropdown  trigger="click">
                <el-button type="primary" size="mini">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="basicsAuth.roleEdit" @click.native="EditRole(scope.$index, scope.row)">修改</el-dropdown-item>
                  <el-dropdown-item v-if="basicsAuth.roleDel" @click.native="DelRole(scope.$index, scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!--分页-->
        </el-table>
        <el-col :span="24" class="toolbar">
          <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pages.total">
          </el-pagination>
          </div>
        </el-col>
      </el-row>
      <!-- 修改信息界面 dialogRoleEdit-->
      <el-dialog :title="textMenu[dialogStatus]" :visible.sync="dialogRoleEdit" :close-on-click-modal="false" @close='emptyDialog'>
        <el-form :label-position="labelPosition" :model="editRole" label-width="100px" :rules="editRoleRules" ref="editRole">
          <el-form-item label="角色名称:" prop="roleName" style="width: 48%;">
            <el-input v-model.trim="editRole.roleName"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="memo">
            <el-input type="textarea" v-model.trim="editRole.memo"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="dialogStatus=='create'" type="success" @click="createData('editRole')">添加</el-button>
          <el-button v-else type="success" @click="updateData('editRole')">保存</el-button>
          <el-button type="warning" @click.native="dialogRoleEdit=false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 修改数据权限界面 dislogChangeQuery -->
      <el-dialog title="修改信息" :visible.sync="dislogChangeQuery" :close-on-click-modal="false">
        <el-card>
          <div slot="header" class="clearfix header">
            <span class="card-header">基本信息</span>
          </div>
          <el-form :label-position="labelPosition" :model="queryForm" label-width="100px" :rules="queryFormRules" ref="queryForm">
            <el-row>
              <el-form-item label="所属角色" prop="role_name" style="width: 48%;" class="fl">
                <el-input v-model.trim="queryForm.role_name"></el-input>
              </el-form-item>
              <el-form-item label="是否为全局授权" prop="query_agree" style="width: 48%;" class="fr">
                <!-- <el-input v-model="queryForm.query_agree"></el-input> -->
                <el-select v-model="queryForm.query_agree" placeholder="请选择活动区域" style="width: 100%;">
                  <el-option label="是" value="yes"></el-option>
                  <el-option label="否" value="no"></el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-form-item label="备注:" prop="remarks">
              <el-input type="textarea" v-model.trim="queryForm.remarks" placeholder="请输入描述信息"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card>
          <div slot="header" class="clearfix header">
            <span class="card-header">数据范围</span>
          </div>
          <el-form :label-position="labelPosition" :model="queryForm" label-width="100px" :rules="queryFormRules" ref="queryForm">
            <el-form-item label="设置数据范围（数据范围为空，表示数据范围为登录者本部门）" prop="query_range">
              <el-input type="textarea" v-model.trim="queryForm.query_range" :disabled="true"></el-input>
            </el-form-item>
          </el-form>
        </el-card>
        
        <div slot="footer" class="dialog-footer">
          <el-button type="success" v-if="basicsAuth.roleAuth" @click="updataChangeQuery()">保存</el-button>
          <el-button type="warning" @click.native="dislogChangeQuery=false">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
    <el-card class="box-card fr" style="width: 60%;">
      <div slot="header" class="clearfix header">
        <span class="card-header fl">功能权限</span>
      </div>
      <ul class="role-table row">
        <li class="header2">
          <div class="left" style="width: 30%;text-align: center;">模块名称</div>
          <div class="right" style="width: 70%;text-align: center;">权限名称</div>
        </li>
        <!-- <div class="vertical-line"></div> -->
        <li v-if="testLists.length === 0" style="border-bottom: 1px solid #e0e0e0;text-align: center;line-height: 40px;">暂无数据</li>
  
        <li v-for="(item,index) in testLists" :key="index">
          <div class="left h40" style="width: 30%;text-align: center;">{{item.menuName}}</div>
          <div class="right h40" style="width: 70%;text-align: center;">
            <el-checkbox-group v-model="checkList">
              <el-checkbox v-for="m in item.children" :label="m.autId" :key="m.id" v-cloak> {{m.autName}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="line"></div>
        </li>
      </ul>
      <div style="width: 100%;" v-show="testLists.length !== 0">
        <el-button type="success" @click="saveRoleAuth()" style="margin: 20px auto;display: block;">保存</el-button>
      </div>
      
    </el-card>
  </div>
</template>
<script>
  import { getRoleList,roleAdd,roleEdit,roleDel,roleInfo,roleAuthInfo,roleAuth } from '../../api/api'
  import treeTable from '@/components/TreeTable'
   import {getPermission} from '../../api/authRequest'
  // import Store from '../../assets/js/store/src/store'
  // import {dateFilter, orderStatus} from '../../util/filter'
  export default {
    name:'roleList',
    components: { treeTable },
    // inject: ['reload'],//注入依赖
    data () {
      return {
        checkList: [],
        testLists: [],
        //分页
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
        labelPosition: 'left', 
        dialogRoleEdit:false,
        dialogStatus:'',
        textMenu: {
          create:'新增角色',
          update: "修改角色",
        },
        dislogChangeQuery:false,
        dialogRoleDel:false,
        roleInfo:[],
        editRole: {
          roleName: "",
          memo:'',
          roleId: '',
        },
        roleList:{},
        editRoleRules: {
          roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        },
        queryForm: {
          roleName: "",
          query_agree:'是',
          remarks:'',
          query_range: ''
        },
        queryFormRules: {
          query_agree: [{ required: true}],
          // query_range: [{required: true}]
        },
        menuList:[],
        allAuthorityList:[],
        roleAuthorityList:[],
        wacthList:'',
        testListsNew:[],
        columns: [        
        {          
          text: '菜单列表',          
          value: 'menuName',          
          width: 200,          
          option: 'sonData1'        
        },        
        {          
          text: '功能权限',          
          value: 'autName',          
          option: 'sonData1',          
          act: 'act'        
        }      
        ],
         basicsAuth:{
                    roleAdd:false,
                    roleDel:false,
                    roleEdit:false,
                    roleAuth:false

                }
      }
    },
    mounted () {
      this.getRoleList()
       this.basicsAuth.roleAdd = getPermission('/system/role/roleAdd');
       this.basicsAuth.roleDel = getPermission('/system/role/roleDel');
        this.basicsAuth.roleEdit = getPermission('/system/role/roleEdit');
         this.basicsAuth.roleAuth = getPermission('/system/role/roleAuth');
       
      // console.log(this.testLists)
    },
    methods: {
      getAuth (data) {
      let opt = []
      data.forEach(val => {
        opt.push(val.id)
        if (val.children) {
          val.children.forEach(el => {
            console.log(val.id)
            if (el.selectchecked.length) {
              opt.push(el.id)
              opt.push(el.selectchecked)
            }
          })
        }
      })
      console.log(data)
      opt = opt.join().split(',').filter(n => { return n })
      console.log(opt)
    },
      //清空dialog
      emptyDialog:function() {
        this.editRole = {}
        this.dialogRoleEdit = false
      },
      // 获取角色信息列表
      getRoleList() {
        let para = {
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        }
        getRoleList(para).then((res) => {
          if (res.data.status ==100) {
            this.roleInfo = res.data.results.list
            this.pages.page = res.data.results.startRow
            this.pages.total = res.data.results.total
          }
        }).catch((error) => {
            this.$Message.error(error.message);
        })
      },
      // 显示新增界面
      AddMenuForm() {
        this.dialogRoleEdit = true;
        this.dialogStatus = "create";
      },
      //确认新增角色内容
      createData(formname) {
        this.$refs[formname].validate((valid) => {
          if (valid) {
            console.log('验证成功')
            /*获取当前input上输入的文字*/
            let para={
              roleName: this.editRole.roleName,
              memo: this.editRole.memo,
            }
            roleAdd(para).then(res => {
              if (res.data.status==100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dialogRoleEdit = false;
                this.$refs[formname].resetFields();
                /*刷新角色列表菜单*/
                this.getRoleList();
              }else{
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //显示修改界面
      EditRole: function(index, row) {
        this.dialogRoleEdit = true;
        this.dialogStatus = "update";
        this.editRole = Object.assign({}, row);
        console.log(this.editRole)
      },
      //保存修改信息
      updateData: function() {
        this.$refs.editRole.validate(valid => {
          if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              let para = Object.assign({}, this.editRole);
              roleEdit(para).then(res => { 
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: "success"
                  });
                  this.$refs["editRole"].resetFields();
                  //this.editFormVisible = false;
                   this.dialogRoleEdit = false;
                  /*刷新角色列表菜单*/
                  this.getRoleList();
                }else{
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
                
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
          }
        });
      },
      //修改数据权限 dislogChangeQuery
      changeQuery(index,row) {
        this.dislogChangeQuery = true;
        this.queryForm = Object.assign({},row);
      },
      updataChangeQuery: function(){
        this.$refs.queryForm.validate(valid => {
          if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              let para = Object.assign({}, this.editRole);
              editUser(para).then(res => {
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: "success"
                  });
                  this.$refs["editRole"].resetFields();
                  this.dialogRoleEdit = false;
                }else{
                  this.$message({
                    message: res.data.message,
                    type: "error"
                  });
                }
                
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
          }
        });
      },
      //删除界面
      DelRole:function (index,row) {
        this.$confirm("确认删除该记录吗?", "提示", {
          type: "warning"
        }).then(() => {
          // alert(row.autId)
          let para = { roleId: row.roleId };
          console.log(para)
          roleDel(para).then(res => {
            if (res.data.status == 100) {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              /*刷新角色列表菜单*/
                this.getRoleList();
            }else{
              this.$message({
                message:res.data.message,
                type: "error"
              });
            }
            
          });
        }).catch(() => {});
      },
      // 点击查看
      openDetails(row) {
        this.wacthList = row
        // console.log(this.wacthList)
        let para = {
          roleId: this.wacthList.roleId,
        }
        roleAuthInfo(para).then((res) => {
          if (res.status ===200) {
            // console.log(res.data.results)
            this.menuList = res.data.results.menuList
            this.allAuthorityList = res.data.results.allAuthorityList
            this.checkList = res.data.results.roleAuthorityList

            var map = {},
                dest = [];
            for(var i = 0; i < this.allAuthorityList.length; i++){
                var ai = this.allAuthorityList[i];
                if(!map[ai.menuId]){
                    dest.push({
                        menuId: ai.menuId,
                        menuName: ai.menuName,
                        children: [ai]
                    });
                    map[ai.menuId] = ai;
                }else{
                    for(var j = 0; j < dest.length; j++){
                        var dj = dest[j];
                        if(dj.menuId == ai.menuId){
                            dj.children.push(ai);
                            break;
                        }
                    }
                }
            }
            // console.log(dest);
            this.testLists = dest
          }
        }).catch((error) => {
            this.$Message.error(error.message);
        })
      },
      // 没有二级菜单
      handleOneCheckedCitiesChange:function (item) { 
        let checkedCount = item.checkeds.length;
        // console.log(checkedCount)
        if (typeof item.isIndeterminate === "undefined") { 
          this.$set(item, "isIndeterminate", false);
        } if (typeof item.checkAll === "undefined") { 
          this.$set(item, "checkAll", false);
        } 
        item.isIndeterminate = checkedCount > 0 && checkedCount < item.authorities.length;
        item.checkAll = checkedCount === item.authorities.length;
        // console.log(item.checkAll)
      },
      handleOneCheckAll:function (event,item) { 
        let arr = [];
        for (let a = 0; a < item.authorities.length; a++) { 
          arr.push(item.authorities[a].autId)
        } 
        item.checkeds = event.target.checked ? arr : [];
        // arr.forEach((data => {
        //   this.checkList.push(data.autId)
        // }))
        console.log(item.checkeds)
      },
      //确认修改权限
      saveRoleAuth() {

        // var obj = document.getElementsByClassName("el-checkbox__original");
        // const check_val = [];
        // for(let k in obj){
        //     if(obj[k].checked)
        //         this.checkList.push(obj[k].value);
        // }
        var arrIdNew = JSON.stringify(this.checkList)
        console.log(this.checkList.toString())
        let para = {
          roleId: this.wacthList.roleId,
          arrID:this.checkList.toString()
        }
        roleAuth(para).then((res) => {
          if (res.data.status == 100) {
            // console.log(res.data.results)
            this.$message({
              message: res.data.message,
              type: "success"
            });
            // this.reload()
            this.getRoleList()
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) => {
            this.$Message.error(error.message);
        })
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pages.pageSize = val
        // console.log(this.configureInfo.pageSize)
        this.getRoleList()
      },
      handleCurrentChange(Page) {
        // console.log(`当前页: ${Page}`);
        this.pages.page = Page
        // console.log(this.configureInfo.currentPage)
        this.getRoleList()
      },
    }
  }
</script>
<style scoped>
   @import '../../assets/css/logistics.css';
   .roleList{font-size: 14px;}
   .roleList .box-card{margin-bottom: 20px;border-radius: 0px;width: 35%;}
   .roleList .box-card .header{background-color: #f5f5f5;font-size: 16px;}
   .roleList .box-card .card-header{font-size: 16px;}
   .roleList .box-card-big{width: 60%;margin-left: 20px;}
   .roleList .role-table {
      border: 1px solid #e0e0e0;
      border-bottom: none;
      padding: 0;
      position: relative;
    }
    .roleList .header2 {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #e7e7e7;
    background: #F8F8F9;
    text-align: center;
    }
    .roleList .vertical-line {
        width: 1px;
        height: 100%;
        background: #ddd;
        position: absolute;
        left: 30%;
        top: 0
    }

    .roleList .left {
        width: 30%;
        float: left;
        padding-left: 10px;
        user-select: none;
        cursor: pointer;
    }
    .roleList .one {
        padding-left: 20px;
    }
    .roleList .right {
        width: 60%;
        float: left;
        padding-left: 10px;
        border-left: 1px solid #ddd;
    }
    .roleList .item-icon {
        margin-left: -5px;
        padding: 5px;
    }
    .roleList .line {
        clear: both;
        width: 100%;
        height: 1px;
        background: #e0e0e0;
    }
    .roleList .h40{
        /*height: 39px;*/
        line-height: 39px;
    }
    [v-cloak] {
        display: none;
    }
    .toolbar{margin:20px 0;}
    .el-checkbox{width: 25%;float: left;text-align: left;}
    .is-checked{margin: 0px;text-align: left;}
    .el-checkbox+.el-checkbox {margin-left: 0px;text-align: left;}
    .roleList .el-table__body{cursor: pointer;}
    .roleList .el-checkbox__input.is-focus .el-checkbox__inner {
      background-color: #000;
    }
    .roleList .current-row{text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// roleList.vue?62dee43f